import { userConstants } from "../../constants/ActionTypes";

const initialState = {
  show_screen:"",
  response_message:"",
};

export function loader(state = initialState, action) {
    switch (action.type) {  
        case userConstants.LOADER:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}